import React, { useContext } from "react";
import { FooterContext } from "../../../../../../store/context/footer-context";
import { ANALYTICS_CATEGORY } from "../../../index.content";
import TrackedLink from "../../../../../Analytics/TrackedLink";
import "./index.scss";

const ContactLink = () => {
  const { t } = useContext(FooterContext);
  return (
    <div className="GCL-F-B-US-CL">
      <p className="GCL-F-B-US-CL__text">{t("Contact us")}</p>
      <TrackedLink
        path="mailto:support@amzscout.net"
        category={ANALYTICS_CATEGORY}
        action="Contact Us"
        classes="GCL-F-B-US-CL__link"
      >
        support@amzscout.net
      </TrackedLink>
    </div>
  );
};

export default ContactLink;
